import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';

import styles from './styles/StorefrontSocial.scss';

import StorefrontCallButton from './StorefrontCallButton.jsx';
import StorefrontSocialShare from './StorefrontSocialShare.jsx';

function StorefrontSocial(props) {
    return (
        <div className={styles.social}>
            {/* Share */}
            <div className={styles.shareButton} data-tn="social-share-cta">
                <div className={styles.socialShareWrapper}>
                    <StorefrontSocialShare disable={props.isPreview} seller={props.seller} />
                </div>
            </div>
            {/* Call */}
            {!!props?.seller?.trackedPhone?.phoneNumber && (
                <StorefrontCallButton
                    className={styles.socialButton}
                    userId={props.user?.serviceId}
                    viewer={props.viewer}
                    seller={props.seller}
                    followDealer={props.followDealer}
                />
            )}
        </div>
    );
}

StorefrontSocial.propTypes = {
    isPreview: PropTypes.bool.isRequired,
    user: PropTypes.object,
    seller: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
    followDealer: PropTypes.func.isRequired,
};

export default createFragmentContainer(StorefrontSocial, {
    seller: graphql`
        fragment StorefrontSocial_seller on Seller {
            ...StorefrontCallButton_seller
            ...StorefrontSocialShare_seller
            trackedPhone {
                phoneNumber
            }
        }
    `,
    user: graphql`
        fragment StorefrontSocial_user on User {
            serviceId
        }
    `,
    viewer: graphql`
        fragment StorefrontSocial_viewer on Viewer {
            ...StorefrontCallButton_viewer
        }
    `,
});
